import _ from 'lodash'
import { connect } from 'react-redux'
import { Paper, Box, Typography, Grid } from '@material-ui/core'
import React, { useRef, useEffect, useState } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import Divider from '@material-ui/core/Divider'
import { Loader, DisplayMessage, Breadcrumb } from '../../Components'
import { OutlinedButton } from '../../elements'
import { SUCCESS, ERROR } from '../../utils/messageTypes'
import { getProgramById } from '../../AppRedux/actions/Programs'
import DownloadFile from '../../utils/downloadFile'
import ProgramFileLogo from '../../elements/icons/programFileLogo'
import UploadProgramFileLogo from '../../elements/icons/uploadProgramFileLogo'
import { programService } from '../../Services/ProgramService'
import {
  MAX_PROGRAM_FILE_SIZE,
  INCENTIVE_VAL,
  INCENTIVE_KEY,
  UPLOAD_OPTION_INDEX,
  incentiveStructureOptions,
  incentive,
  CONTROL_TYPES
} from './constant'
import { useStyles } from './style'
import moment from 'moment'
import Error404 from '../ErrorPages/Error404'
import { EditOutlined } from '@material-ui/icons'
import sun from '../../Assets/Images/sun.svg'
import home2 from '../../Assets/Images/home2.svg'
import report from '../../Assets/Images/report.svg'
import phone from '../../Assets/Images/phone.svg'
import { getProgramDetailsEventFlagValue } from './utils'
import { DEFAULT, AUTONOMOUS } from './constant'


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const ProgramDetails = (props) => {
  const [loading, setLoading] = useState(false)
  const [programFileOption, setProgramFileOption] = useState(null)
  const [incentiveKey, setIncentiveKey] = useState(INCENTIVE_KEY)
  const [incentiveValue, setIncentiveValue] = useState(INCENTIVE_VAL)
  const [programMetadata, setProgramMetadata] = useState({})
  const [programFileDownloadLink, setProgramFileDownloadLink] = useState(null)
  const [currentUploadOptionIndex, setCurrentUploadOptionIndex] = useState(
    UPLOAD_OPTION_INDEX,
  )
  const [openSnackBarFileSize, setOpenSnackBarFileSize] = useState(false)
  const [openSnackBarFileType, setOpenSnackBarFileType] = useState(false)
  const [programFileKey, setProgramFileKey] = useState(null)
  const hiddenFileInput = useRef(null)
  const classes = useStyles()
  const currentUser = props.currentUser
  const [showMessage, setShowMessage] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState(SUCCESS)

  const isAutonomous = props.programDetails?.feature_flags?.event_feature_config?.AUTONOMOUS
  const marginLeft = 0.625

  useEffect(() => {
    const id = _.get(props.match.params, 'programs_id', '')
    if (props.accountId && id && id !== props.programId) {
      props.getProgramById({
        accountId: props.accountId,
        programId: id,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params, props.programId, props.accountId])

  useEffect(() => {
    setShowMessage(_.get(props.location, 'showMessage', false))
    setMessage(_.get(props.location, 'message', ''))
    setMessageType(_.get(props.location, 'messageType', SUCCESS))
  }, [props.location])

  const handleSnackBarFileSizeClose = () => {
    setOpenSnackBarFileSize(false)
  }
  const handleSnackBarFileTypeClose = () => {
    setOpenSnackBarFileType(false)
  }
  useEffect(() => {
    if (
      _.get(props.programDetails, 'program_enrollment_form_metadata_id', '')
    ) {
      setLoading(true)
      programService
        .getProgramMetadataOfCurrentProgramAPICall(
          _.get(
            props.programDetails,
            'program_enrollment_form_metadata_id',
            '',
          ),
          props.accountId,
        )
        .then((data) => {
          setProgramMetadata(data.data.data)
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
        })
    }
    const incentive_structure = _.get(
      props.programDetails,
      'incentive_structure',
      { CUSTOM: '0$' },
    )
    Object.keys(incentive_structure).forEach((key, value) => {
      setIncentiveKey(key)
      setIncentiveValue(incentive_structure[key])
    })
  }, [currentUser.account_id, props.accountId, props.programDetails])

  useEffect(() => {
    if (programFileDownloadLink) DownloadFile(programFileDownloadLink)
  }, [programFileDownloadLink])

  const handleEditProgram = () => {
    props.history.replace({
      pathname: `/program-request/${props.programId}`,
    })
  }

  const incentive_structure_key = (incentiveKey) => {
    switch (incentiveKey) {
      case incentiveStructureOptions.UPFRONT_DISCOUNT.value:
        return incentiveStructureOptions.UPFRONT_DISCOUNT.label
      case incentiveStructureOptions.CUSTOM.value:
        return incentiveStructureOptions.CUSTOM.label
      case incentiveStructureOptions.SEASONAL_PERFORMANCE_INCENTIVES.value:
        return incentiveStructureOptions.SEASONAL_PERFORMANCE_INCENTIVES.label
      default:
        return incentiveStructureOptions.CUSTOM.label
    }
  }

  const getControlTypes = (controlTypes = []) => {
    return controlTypes.map(type => CONTROL_TYPES[type])
  }
  //program details screen
  const programDetailsLeft = [
    {
      key: 'Name of Program',
      value: _.get(props.programDetails, 'program_name_admin_ui', ''),
    },
    {
      key: 'Program Name Visible in Enlighten',
      value: _.get(props.programDetails, 'name', ''),
    },
    {
      key: 'Account',
      value: _.get(props.programDetails, 'account_name', ''),
    },
    {
      key: 'Country',
      value: _.get(props.programDetails, 'country', ''),
    },
    {
      key: 'State',
      value: _.get(props.programDetails, 'state', ''),
    },
    {
      key: 'Utility Name',
      value: _.get(props.programDetails, 'utility_name', ''),
    },
    {
      key: 'Incentive Structure',
      value: incentive_structure_key(incentiveKey),
    },
  ]
  const programDetailsRight = [
    {
      key: incentive[incentiveKey],
      value: incentiveValue,
    },
    {
      key: 'Maximum Enrollment',
      value: _.get(props.programDetails, 'max_system_enrollments', ''),
    },
    {
      key: 'Program End Date',
      value: _.get(props.programDetails, 'program_end_date') ? moment(props.programDetails.program_end_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : '',
    },
    ...(props.isSuperAdmin ?
      [
        {
          key: 'Enrollment Web Link',
          value: _.get(props.programDetails, 'enrollment_web_link', ''),
        }
      ] : []),
    {
      key: '',
      value: '',
    },
  ]

  const uploadOptions = [
    {
      key: 'enrollment_forms',
      value: 'Application Form',
      sourcePath: programMetadata.enrollment_form_source_path,
    },
    {
      key: 'tandc_forms',
      value: 'Terms & Condition',
      sourcePath: programMetadata.tandc_form_source_path,
    },
    {
      key: 'incentivestructure_files',
      value: 'Incentive Structure',
      sourcePath: programMetadata.incentive_structure_source_path,
    },
    {
      key: 'programdetails_files',
      value: 'Program Details',
      sourcePath: programMetadata.program_details_source_path,
    },
  ]

  const minimumEswDetails = [
    {
      id: 'minimumeSw',
      name: 'minimumeSw',
      label: 'Minimum Envoy Software Version',
      type: 'multiText',
      options: [
        {
          name: 'minEswBattery',
          label: 'Battery',
          dependency: 'BATTERY',
          flag: 'min_eSW_Battery'
        },
        {
          name: 'minEswExportLimit',
          label: 'Export Limit',
          dependency: 'export_limit',
          flag: 'min_eSW_ExportLimit'
        },
        {
          name: 'minEswPv',
          label: 'PV',
          dependency: 'PV',
          flag: 'min_eSW_PV'
        },
      ]
    },
  ]
  const openADRConfiguration = [
    {
      id: 'openadr_service_enabled',
      key: 'OpenADR 2.0b service for program',
      value: _.get(props.programDetails, 'feature_flags.openadr_service_enabled') ? 'Enabled' : 'Disabled',
    },
    {
      id: 'openADR_enrollment_service',
      key: 'OpenADR enrollment service',
      value: _.get(props.programDetails, 'feature_flags.openADR_enrollment_service') ? 'Enabled' : 'Disabled',
    },
    {
      id: 'openADR_event_service',
      key: 'OpenADR event service',
      value: _.get(props.programDetails, 'feature_flags.openADR_event_service') ? 'Enabled' : 'Disabled',
    },
    {
      id: 'openADR_report_service',
      key: 'OpenADR report service',
      value: _.get(props.programDetails, 'feature_flags.openADR_report_service') ? 'Enabled' : 'Disabled',
    },
    {
      id: 'openADR_optOut_service',
      key: 'OpenADR optOut service',
      value: _.get(props.programDetails, 'feature_flags.openADR_optOut_service') ? 'Enabled' : 'Disabled',
    },
  ]

  const csipConfiguration = [
    {
      id: 'csip_enabled',
      key: 'CSIP Enabled',
      value: _.get(props.programDetails, 'feature_flags.csip_enabled') ? 'Enabled' : 'Disabled',
    },
    {
      id: 'csip_profile',
      key: 'Profile',
      value: _.get(props.programDetails, 'feature_flags.csip_profile', ''),
    },
    {
      id: 'csip_der_capability_fields',
      key: 'Der Capability Fields',
      value: Array.isArray(props.programDetails?.feature_flags?.csip_der_capability_fields)
              ? props.programDetails.feature_flags.csip_der_capability_fields.join(', ')
              : '--',
    },
    {
      id: 'csip_der_settings_fields',
      key: 'Der Settings Fields',
      value: Array.isArray(props.programDetails?.feature_flags?.csip_der_settings_fields)
              ? props.programDetails.feature_flags.csip_der_settings_fields.join(', ')
              : '--',
    },
    {
      id: 'csip_allowed_controls',
      key: 'Allowed Controls',
      value: Array.isArray(props.programDetails?.feature_flags?.csip_allowed_controls)
              ? props.programDetails.feature_flags.csip_allowed_controls.join(', ')
              : '--',
    },
    {
      id: 'csip_mup_fields',
      key: 'Telemetry Fields',
      value: Array.isArray(props.programDetails?.feature_flags?.csip_mup_fields)
              ? props.programDetails.feature_flags.csip_mup_fields.join(', ')
              : '--',
    },
    {
      id: 'csip_der_status_fields',
      key: 'Der Status Fields',
      value: Array.isArray(props.programDetails?.feature_flags?.csip_der_status_fields)
              ? props.programDetails.feature_flags.csip_der_status_fields.join(', ')
              : '--',
    },
    {
      id: 'csip_envoy_enabled',
      key: 'Csip Envoy Enabled',
      value: _.get(props.programDetails, 'feature_flags.csip_envoy_enabled') ? 'Enabled' : 'Disabled',
    },
    {
      id: 'csip_in_band_reg_enabled',
      key: 'In-Band Registration Enabled',
      value: _.get(props.programDetails, 'feature_flags.csip_in_band_reg_enabled') ? 'Enabled' : 'Disabled',
    },
    {
      id: 'csip_direct_client',
      key: 'Csip Direct Client',
      value: _.get(props.programDetails, 'feature_flags.csip_direct_client') ? 'Enabled' : 'Disabled',
    }
  ]

  const getValue = (flag, parameter) => {
    if (props.programDetails && props.programDetails?.feature_flags && (parameter === DEFAULT || parameter === AUTONOMOUS)) {
      const featureConfig = props.programDetails?.feature_flags?.event_feature_config
      if (featureConfig && parameter in featureConfig && flag in featureConfig[parameter]) {
        return featureConfig[parameter][flag]
      }
    } else if (props.programDetails?.feature_flags && flag in props.programDetails?.feature_flags) {
      return props.programDetails?.feature_flags[flag]
    }
    return '--'
  }

  const getEventConfiguration = (label, flag, isSuperAdmin) => (
    <div className={classes.contentWrapper} style={{ alignItems: 'center' }}>
      <Grid item xs={6}>
        <span className={classes.programDetailsCardCellKey}>{label}</span>
      </Grid>
      <div className={classes.eventConfigWrapper}>
        {(isSuperAdmin || props.isViewOnly) &&
          <div className={`${classes.programDetaislCardCellValue} ${classes.programFlagWrapper}`}>
            {(flag === 'max_event_duration' || flag === 'min_event_duration') ? (getValue(flag) === '--' ? '--' : getValue(flag) / 1000) : getValue(flag) === true ? 'Enabled' : getValue(flag) === false ? 'Disabled' : '--'}
          </div>
        }
        <div className={classes.programFlagCell} style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            {(props.programDetails?.feature_flags?.event_feature_config?.DEFAULT !== undefined) &&
              <div className={`${classes.programDetaislCardCellValue} ${classes.programFlagCell}`} style={{ width: (isAutonomous && isSuperAdmin) ? '50%' : '100%' }}>
                {(flag === 'max_event_duration' || flag === 'min_event_duration') ? (getValue(flag, DEFAULT) === '--' ? '--' : getValue(flag, DEFAULT) / 1000) : getValue(flag, DEFAULT) === true ? 'Enabled' : getValue(flag, DEFAULT) === false ? 'Disabled' : '--'}
              </div>
            }
            {(isSuperAdmin || props.isViewOnly) && (props.programDetails?.feature_flags?.event_feature_config?.AUTONOMOUS !== undefined) &&
              <div className={`${classes.programDetaislCardCellValue} ${classes.programFlagCell}`} style={{ width: '50%' }}>
                {(flag === 'max_event_duration' || flag === 'min_event_duration') ? (getValue(flag, AUTONOMOUS) === '--' ? '--' : getValue(flag, AUTONOMOUS) / 1000) : getValue(flag, AUTONOMOUS) === true ? 'Enabled' : getValue(flag, AUTONOMOUS) === false ? 'Disabled' : '--'}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )

  const getProgramSpecificConfigurations = (isSuperAdmin) => (
    <>
      <Grid item md={6}>
        <Grid container spacing={2} className={classes.moduleContainer}>
          <div className={classes.contentWrapper} style={{ padding: '0px' }}>
            <Grid item xs={6}>
              <Box className={classes.programConfigSubHeading}><img src={sun} className={classes.moduleIcons} alt="" /> EVENT CONFIGURATION</Box>
            </Grid>
            <div className={classes.eventConfigWrapper}>
              {(isSuperAdmin || props.isViewOnly) && <div className={`${classes.programDetaislCardCellValue} ${classes.programFlagWrapper}`}>PROGRAM</div>}
              <div className={`${classes.fieldWrapper} ${classes.programFlagCell}`} style={{ width: '100%' }}>
                <div className={`${classes.programDetaislCardCellValue} ${classes.programFlagCell}`} style={{ paddingBottom: '10px' }}>OVERRIDE</div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className={`${classes.programDetaislCardCellValue} ${classes.programFlagCell}`} style={{ width: (isAutonomous && isSuperAdmin) ? '50%' : '100%' }}>One-Time</div>
                  {(isSuperAdmin || props.isViewOnly) && isAutonomous && <div className={`${classes.programDetaislCardCellValue} ${classes.programFlagCell}`} style={{ width: '50%' }}>Recurring</div>}
                </div>
              </div>
            </div>
          </div>
          <Grid item xs={12}>
            <Divider />
          </Grid>

          {getEventConfiguration('Event Cancellation Allowed for Upcoming Events', 'event_cancellation_allowed_for_upcoming_events', isSuperAdmin)}
          {getEventConfiguration('Event Ending Allowed for Ongoing Events', 'event_ending_allowed_for_ongoing_event', isSuperAdmin)}
          {getEventConfiguration('Event opt in/ opt out capability', 'event_opt_in_opt_out_capability', isSuperAdmin)}
          {(isSuperAdmin || props.isViewOnly) && getEventConfiguration('Target SoC Override', 'target_soc_override', isSuperAdmin)}
          {(isSuperAdmin || props.isViewOnly) && getEventConfiguration('Scheduled Power Override', 'scheduled_power_override', isSuperAdmin)}
          {(isSuperAdmin || props.isViewOnly) && getEventConfiguration('Enable Storm Guard Override', 'storm_guard_override', isSuperAdmin)}
          {(isSuperAdmin || props.isViewOnly) && getEventConfiguration('Maximum Event Duration (seconds)', 'max_event_duration', isSuperAdmin)}
          {(isSuperAdmin || props.isViewOnly) && getEventConfiguration('Minimum Event Duration (seconds)', 'min_event_duration', isSuperAdmin)}

          <Grid item xs={12}>
            <Divider />
          </Grid>
          {(isSuperAdmin || props.isViewOnly) && props.programDetails && props.programDetails.feature_flags && props.programDetails.feature_flags.functions?.length > 0 &&
            <>
              <Grid container item xs={12}>
                <Grid item xs={4}>
                  <span className={classes.programDetailsCardCellKey}>Control Type</span>
                </Grid>
                <Grid item xs={8} container justify="flex-end">
                  <span className={classes.programDetaislCardCellValue} mx={1}>{props.programDetails?.feature_flags?.control_type ? getControlTypes(props.programDetails.feature_flags.control_type).join(', ') : '-'}</span>
                </Grid>
              </Grid>
              <Grid container item xs={12}>
                <Grid item xs={4}>
                  <span className={classes.programDetailsCardCellKey}>Functions</span>
                </Grid>
                <Grid item xs={8} container justify="flex-end">
                  <span className={classes.programDetaislCardCellValue} mx={1}>{props.programDetails?.feature_flags?.functions ? props.programDetails.feature_flags.functions.join(', ') : '-'}</span>
                </Grid>
              </Grid>
            </>
          }
          {(isSuperAdmin || props.isViewOnly) && 
            minimumEswDetails.map((obj, index) => (
              <Box className={classes.labelWrapper} width='98%' ml={marginLeft} justifyContent='space-between'>
                <Grid item xs={4}>
                  <Box className={classes.programDetailsCardCellKey}>{obj.label}</Box>
                </Grid>
                <Grid item xs={7}>
                  <Box className={classes.fieldWrapper}>
                  {obj.options.map((item, index) => 
                    <Box className={classes.multiFieldValues}>
                      <Typography className={classes.programDetailsCardCellKey}>{item.label}</Typography>
                      <Typography className={classes.programDetaislCardCellValue}>{_.get(props.programDetails?.feature_flags, item.flag, '')}</Typography>
                    </Box>)
                  }
                  </Box>
                </Grid>
              </Box>
            ))
          }
          {_.get(props, 'programDetails.feature_flags') && props.programDetails.feature_flags.functions.includes("EVSE") &&
            <>
              <Grid item xs={4}>
                <Box className={classes.eventTypeBox}>EVSE Control Type</Box>
              </Grid>
              <Grid item xs={8}>
                <Box display="flex" flexWrap="wrap">
                  <Box className={classes.eventSubTypeBox}>
                    <Box className={classes.subTypeBoxHeading}>{_.get(props.programDetails, 'feature_flags.evse_control_type', '')}</Box>
                  </Box>
                </Box>
              </Grid>
            </>
          }
          <Grid container item xs={12}>
            <Grid item xs={4}>
              <Box className={classes.programDetailsCardCellKey}>Event Type</Box>
            </Grid>
            <Grid item xs={8}>
              <Box className={classes.programDetailsCardCellKey} mx={1}>Event Subtype</Box>
            </Grid>
            {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_types.includes('BATTERY_CHARGE') &&
              <>
                <Grid item xs={4}>
                  <Box className={classes.eventTypeBox}>Charge Event</Box>
                </Grid>
                <Grid item xs={8}>
                  <Box display="flex" flexWrap="wrap">
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Charge_From_PV') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Charge From PV</Box>
                        <Box my={1}>
                          <Divider />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                          <Box className={classes.subTypeBoxContent}>Target SoC (%)</Box>
                          <Box className={classes.programConfigSubHeading}>{props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Charge_From_PV')?.max_target_soc}</Box>
                        </Box>
                      </Box>
                    }
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Charge_From_NetPV') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Charge From Net PV</Box>
                        <Box my={1}>
                          <Divider />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                          <Box className={classes.subTypeBoxContent}>Target SoC (%)</Box>
                          <Box className={classes.programConfigSubHeading}>{props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Charge_From_NetPV')?.max_target_soc}</Box>
                        </Box>
                      </Box>
                    }
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Charge_From_PV_Grid') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Charge From PV and Grid</Box>
                        <Box my={1}>
                          <Divider />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                          <Box className={classes.subTypeBoxContent}>Target SoC (%)</Box>
                          <Box className={classes.programConfigSubHeading}>{props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Charge_From_PV_Grid')?.max_target_soc}</Box>
                        </Box>
                      </Box>
                    }
                  </Box>
                </Grid>
              </>
            }
            {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_types.includes('BATTERY_DISCHARGE') &&
              <>
                <Grid item xs={4}>
                  <Box className={classes.eventTypeBox}>Discharge Event</Box>
                </Grid>
                <Grid item xs={8}>
                  <Box display="flex" flexWrap="wrap">
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Discharge_To_Load') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Discharge to Load</Box>
                        <Box my={1}>
                          <Divider />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                          <Box className={classes.subTypeBoxContent}>Target SoC (%)</Box>
                          <Box className={classes.programConfigSubHeading}>{props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Discharge_To_Load')?.min_target_soc}</Box>
                        </Box>
                      </Box>
                    }
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Discharge_To_NetLoad') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Discharge to Net Load</Box>
                        <Box my={1}>
                          <Divider />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                          <Box className={classes.subTypeBoxContent}>Target SoC (%)</Box>
                          <Box className={classes.programConfigSubHeading}>{props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Discharge_To_NetLoad')?.min_target_soc}</Box>
                        </Box>
                      </Box>
                    }
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Discharge_To_Load_Grid') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Discharge to Load and Grid</Box>
                        <Box my={1}>
                          <Divider />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                          <Box className={classes.subTypeBoxContent}>Target SoC (%)</Box>
                          <Box className={classes.programConfigSubHeading}>{props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Discharge_To_Load_Grid')?.min_target_soc}</Box>
                        </Box>
                      </Box>
                    }
                  </Box>
                </Grid>
              </>
            }
            {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_types.includes('IDLE') &&
              <>
                <Grid item xs={12}>
                  <Box className={classes.eventTypeBox}>Idle Event</Box>
                </Grid>
              </>
            }
            {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_types.includes('pv_curtailment') &&
              <>
                <Grid item xs={12}>
                  <Box className={classes.eventTypeBox}>PV Curtailment</Box>
                </Grid>
              </>
            }
            {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_types.includes('export_limit') &&
              <>
                <Grid item xs={12}>
                  <Box className={classes.eventTypeBox}>Export Limit</Box>
                </Grid>
              </>
            }
            {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_types.includes('hp_control') &&
              <>
                <Grid item xs={4}>
                  <Box className={classes.eventTypeBox}>HP Control</Box>
                </Grid>
                <Grid item xs={8}>
                  <Box display="flex" flexWrap="wrap">
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'MODE_1') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Mode 1</Box>
                      </Box>
                    }
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'MODE_2') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Mode 2</Box>
                      </Box>
                    }
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'MODE_3') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Mode 3</Box>
                      </Box>
                    }
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'MODE_4') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Mode 4</Box>
                      </Box>
                    }
                  </Box>
                </Grid>
              </>
            }
            {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_types.includes('evse_control') &&
              <>
                <Grid item xs={4}>
                  <Box className={classes.eventTypeBox}>EVSE Control</Box>
                </Grid>
                <Grid item xs={8}>
                  <Box display="flex" flexWrap="wrap">
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Charge') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Charge</Box>
                      </Box>
                    }
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'Dont_Charge') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Dont Charge</Box>
                      </Box>
                    }
                  </Box>
                </Grid>
              </>
            }
            {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_types.includes("hvac_control") &&
              <>
                <Grid item xs={4}>
                  <Box className={classes.eventTypeBox}>HVAC Control</Box>
                </Grid>
                <Grid item xs={8}>
                  <Box display="flex" flexWrap="wrap">
                    {_.get(props, 'programDetails.feature_flags.event_types') && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === 'SETPOINT_OFFSET') &&
                      <Box className={classes.eventSubTypeBox}>
                        <Box className={classes.subTypeBoxHeading}>Setpoint Offset</Box>
                      </Box>
                    }
                  </Box>
                </Grid>
              </>
            }
          </Grid>
          {(isSuperAdmin || props.isViewOnly) &&
            <>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Minimum Rate Watt (percent)</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.minimum_rate_watt_percent', 10)}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Command Retry Time Interval Post Start (seconds)</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.command_retry_time_interval_post_start', 0)}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Event Lead Time (seconds)</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.event_lead_time', 0)}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Battery Full-Backup mode Prior Hours</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{(() => {
                  const value = _.get(props.programDetails, 'battery_lock_config.DISPATCH.hours_duration', '')
                  return (value === null || value === -1 || value === '') ? '--' : value
                })()}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Activate Real Time Dispatch</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.activate_real_time_dispatch', false) ? 'Enabled' : 'Disabled'}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Enact Enabled</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.enact_enabled', false) ? 'Enabled' : 'Disabled'}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Enable Collect Telemetry</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.enable_collect_telemetry', true) ? 'Enabled' : 'Disabled'}</span>
              </Grid>
               <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Enable Forecast</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.enable_forecast', true) ? 'Enabled' : 'Disabled'}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Live Stream Telemetry Enabled</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.live_stream_telemetry_enabled', false) ? 'Enabled' : 'Disabled'}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Live Stream Telemetry Frequency</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.live_stream_telemetry_frequency', 0)}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.programDetailsCardCellKey}>Live Stream Telemetry Customer Name</span>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <span className={classes.programDetaislCardCellValue}>{props.programDetails?.feature_flags?.live_stream_telemetry_customer_name?.length > 0 ? props.programDetails.feature_flags.live_stream_telemetry_customer_name.join(', ') : '--'}</span>
              </Grid>
            </>
          }
        </Grid>
        {(isSuperAdmin || props.isViewOnly) &&
          <Grid container spacing={2} className={classes.moduleContainer}>
            <Grid item xs={12}>
              <Box className={classes.programConfigSubHeading}><img src={report} className={classes.moduleIcons} alt="" />REPORTS</Box>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Program and events</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.program_and_events', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>System reports</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.system_reports', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Forecasting reports</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.forecasting_reports', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>User reports</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.user_reports', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
          </Grid>
        }
      </Grid>
      {(isSuperAdmin || props.isViewOnly) &&
        <Grid item md={6}>
          <Grid container spacing={2} className={classes.moduleContainer}>
            <Grid item xs={12}>
              <Box className={classes.programConfigSubHeading}><img src={phone} className={classes.moduleIcons} alt="" />HOMEOWNER ENLIGHTEN APP BASED ENROLMENT</Box>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Input fields, Terms and Conditions, Signatures</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.input_fields_terms_and_conditions_signatures', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Committed power in program</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.committed_power_in_program', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Committed energy in program</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.committed_energy_in_program', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Site On Grid/ Off Grid Feature</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{getProgramDetailsEventFlagValue(props.programDetails, 'site_on_grid_off_grid_feature', false)}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Battery Reserve SoC configurability</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.battery_reserve_soc_configurability', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Potential earnings applicable for program</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.potential_earnings_applicable_for_program', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Incentive Calculation Formulae</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.incentive_calculation_formulae', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Installer Intake Portal based Enrolment</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.installer_intake', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Customer Support View</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.customer_support_verification', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Grid>
          <Grid container spacing={2} className={classes.moduleContainer}>
            <Grid item xs={12}>
              <Box className={classes.programConfigSubHeading}><img src={home2} className={classes.moduleIcons} alt="" />SYSTEM ENROLMENT</Box>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Systems Enrollment Option</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.system_enrollment_option', '') ? props.programDetails.feature_flags.system_enrollment_option.replace('_', ' ') : ''}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>System access authorization</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.system_access_list', '') ? props.programDetails.feature_flags.system_access_list.join(', ') : ''}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Unsupported Micro Models</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{props.programDetails?.feature_flags?.unsupported_solar_micros?.length > 0 ? props.programDetails.feature_flags.unsupported_solar_micros.join(', ') : '--'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Minimum Allowed Site Stage [0-5]</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.min_site_stage', 4)}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Allowed Sites</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>Enabled</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Allowed Zip Codes</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>Enabled</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Pcu Bin Width (seconds)</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.pcu_bin_width', 0)}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Pcu Polling Interval (seconds)</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.pcu_polling_interval', 0)}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Rgm Bin Width (seconds)</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.rgm_bin_width', 0)}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Rgm Polling Interval (seconds)</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.rgm_polling_interval', 0)}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Reporting Interval Period (seconds)</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.reporting_interval_period', 0)}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Sftp Enrollment Files To Energyhub</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.sftp_enrollment_files_to_energyhub', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Auto Unenroll Sites</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.auto_unenroll_sites', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Program Standardization</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.program_standardization', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Enho App Intake</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.enho_app_intake', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Enrolled HomeOwner experience</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.enrolled_ho_exp', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Solar Only Homeowner experience</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.solar_only_ho_exp', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Solar Storage Homeowner experience</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.solar_storage_ho_exp', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Storage Only Homeowner experience</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.storage_only_ho_exp', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Sync Enrollments</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.sync_enrollments', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>Enable Bulk Event Dispatch</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.enable_bulk_event_dispatch', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
          </Grid>

          <Grid container spacing={2} className={classes.moduleContainer}>
            <Grid item xs={12}>
              <Box className={classes.programConfigSubHeading}><img src={home2} className={classes.moduleIcons} alt="" />THIRD PARTY CONTROL</Box>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>External Steering Mode</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.external_steering_mode', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>CFG</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.cfg', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>DTG</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.dtg', false) ? 'Enabled' : 'Disabled'}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>TPC Name</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.tpc_name', '')}</span>
            </Grid>
            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>TPC Program</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.tpc_program', '')}</span>
            </Grid>

            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>RSOC [0-100%]</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.rsoc', '')}</span>
            </Grid>

            <Grid item xs={6}>
              <span className={classes.programDetailsCardCellKey}>VLS [5-25%]</span>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <span className={classes.programDetaislCardCellValue}>{_.get(props.programDetails, 'feature_flags.vls', '')}</span>
            </Grid>
          </Grid>
        </Grid>
      }
    </>
  )

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0]
    if (event.target.files[0]?.name?.split('.').length <= 2) {
      if (fileUploaded) {
        if (event.target.files[0].size > MAX_PROGRAM_FILE_SIZE)
          setOpenSnackBarFileSize(true)
        else if (event.target.files[0].type !== 'application/pdf')
          setOpenSnackBarFileType(true)
        else {
          if (fileUploaded != null) {
            const payload = {
              program_enrollment_form_metadata_id: _.get(
                props.programDetails,
                'program_enrollment_form_metadata_id',
                '',
              ),
              file: fileUploaded,
              program_file_key: programFileKey,
              accountId: currentUser.account_id,
            }
            setLoading(true)
            programService
              .postProgramFilesRequest(payload)
              .then((data) => {
                setLoading(false)
                setProgramMetadata(data.data.data)
              })
              .catch(error => {
                setShowMessage(true)
                setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
                setMessageType(ERROR)
                setLoading(false)
              })
          }
        }
      }
    } else {
      setOpenSnackBarFileType(true)
    }
  }

  const renderNavValue = () => {
    const nav = [{ Home: '/' }]
    nav.push(
      { Programs: '/programs' },
      {
        [_.get(
          props.programDetails,
          'program_name_admin_ui',
          '',
        )]: `/programs/${props.programId}`,
      },
      { 'Program Settings': '' },
    )
    return nav
  }
  return (
    <>
      {props.notFound ? <Error404 /> :
        <>
          <input
            accept={'application/pdf'}
            type="file"
            ref={hiddenFileInput}
            onChange={(event) => handleChange(event)}
            onClick={(event) => {
              hiddenFileInput.current.value = ''
            }}
            style={{ display: 'none' }}
          />
          <Breadcrumb value={renderNavValue()} />
          <Box className={classes.programDetailsViewer}>
            <Box className={classes.programsHeaderWrapper}>
              <Typography className={classes.title}>Program Settings</Typography>
            </Box>
            <Paper className={classes.programDetailsBody} elevation={5}>
              <Box>
                <Box className={classes.headerWrapper}>
                  <Box>Program Highlights</Box>
                  {!props.isViewOnly && props.isAdmin && <EditOutlined onClick={handleEditProgram} className={classes.icons} />}
                </Box>
                <Box className={classes.programDetailsCard}>
                  <Box className={classes.programDetailsCardValue}>
                    <Grid container spacing={6}>
                      <Grid item md={6}>
                        <Grid container spacing={2}>
                          {programDetailsLeft.map((cell) => {
                            return (
                              <>
                                <Grid className={classes.programDetailsCardCellKey} item xs={6}>
                                  {cell.key}
                                </Grid>
                                <Grid className={classes.programDetaislCardCellValue} item xs={6} container justify="flex-end">
                                  {cell.value}
                                </Grid>
                              </>
                            )
                          })}
                        </Grid>
                      </Grid>
                      <Grid item md={6}>
                        <Grid container spacing={2}>
                          {programDetailsRight.map((cell) => {
                            return (
                              <>
                                <Grid className={classes.programDetailsCardCellKey} item xs={6}>
                                  {cell.key}
                                </Grid>
                                <Grid className={classes.programDetaislCardCellValue} item xs={6} container justify="flex-end">
                                  {cell.value}
                                </Grid>
                              </>
                            )
                          })}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                {(props.isSuperAdmin || props.isAdmin || props.isViewOnly) &&
                  <>
                    <Box className={classes.headerWrapper}>
                      <Box>Program Specific Configurations</Box>
                      {!props.isViewOnly && props.isAdmin && <EditOutlined onClick={handleEditProgram} className={classes.icons} />}
                    </Box>
                    <Box m={4}>
                      <Grid container spacing={6}>
                        {getProgramSpecificConfigurations(props.isSuperAdmin)}
                      </Grid>
                    </Box>
                  </>
                }
              </Box>
              <Box className={classes.boxWrapper}>
                <Box className={classes.sectionWrapper}>
                  <Box>
                    {(props.isSuperAdmin || props.isViewOnly) &&
                      <>
                        <Box className={classes.headerWrapper}  width={'95%'}>
                          <Box>OpenADR Configurations</Box>
                        </Box>
                        <Box m={4}>

                          <Grid container spacing={3} >
                            {openADRConfiguration.map((cell) => {
                              return (
                                <>
                                  <Grid className={classes.programDetailsCardCellKey} item xs={6}>
                                    {cell.key}
                                  </Grid>
                                  <Divider />
                                  <Grid className={classes.programDetaislCardCellValue} item xs={6} container justify="flex-end">
                                    {cell.value}
                                  </Grid>
                                </>
                              )
                            }
                            )
                            }

                          </Grid>

                        </Box>
                      </>
                    }
                  </Box>
                </Box>
                <Box className={classes.csipSectionWrapper}>
                  <Box>
                    {(props.isSuperAdmin || props.isViewOnly) &&
                      <>
                        <Box className={classes.headerWrapper} >
                          <Box>CSIP Configuration</Box>
                        </Box>
                        <Box m={4}>

                          <Grid container spacing={3} >
                            {csipConfiguration.map((cell) => {
                              return (
                                <>
                                  <Grid className={classes.programDetailsCardCellKey} item xs={6}>
                                    {cell.key}
                                  </Grid>
                                  <Divider />
                                  <Grid className={classes.programDetaislCardCellValue} item xs={6} container justify="flex-end">
                                    {cell.value}
                                  </Grid>
                                </>
                              )
                            }
                            )
                            }

                          </Grid>

                        </Box>
                      </>
                    }
                  </Box>
                </Box>
              </Box>
            </Paper>
            {(props.isSuperAdmin || props.isViewOnly) &&
              <Paper className={classes.programFilesBody} elevation={5}>
                <Box className={classes.headerWrapper}>Program Files</Box>
                <Box className={classes.programFilesOptions}>
                  {uploadOptions.map((option, index) => {
                    return props.isAdmin || option.sourcePath ? (
                      <Box
                        key={index}
                        className={classes.programFilesAction}
                        onClick={() => {
                          setCurrentUploadOptionIndex(index)
                          if (option.sourcePath) setProgramFileOption(option)
                          else setProgramFileOption(null)
                        }}
                        style={
                          currentUploadOptionIndex === index
                            ? { backgroundColor: '#FFF' }
                            : {}
                        }
                      >
                        {option.sourcePath ? (
                          <>
                            <Box
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-around',
                                alignItems: 'center',
                              }}
                            >
                              <ProgramFileLogo></ProgramFileLogo>
                              <Box
                                style={{
                                  padding: '1em 1em 0em 1em',
                                  fontWeight: 'bold',
                                  color: '#6B7073',
                                }}
                              >
                                {option.value}
                              </Box>
                            </Box>
                          </>
                        ) : (
                          <>
                            {' '}
                            <UploadProgramFileLogo></UploadProgramFileLogo>
                            <Typography
                              style={{ fontWeight: 'bold', color: '#6B7073' }}
                            >
                              {_.get(option, 'value', 'Application Form Value')}
                            </Typography>
                            <OutlinedButton
                              label="Upload"
                              width="10rem"
                              disabled={props.isViewOnly}
                              onClick={() => {
                                setProgramFileKey(option.key)
                                hiddenFileInput.current.click()
                              }}
                            ></OutlinedButton>
                          </>
                        )}
                      </Box>
                    ) : null
                  })}
                </Box>
                {programFileOption ? (
                  <Box>
                    <Divider
                      variant="middle"
                      className={classes.formDividerInstallerDetails}
                    />
                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        padding: '1em 2em 1em 2em',
                      }}
                    >
                      {!props.isViewOnly && props.isAdmin ? (
                        <OutlinedButton
                          label="Delete"
                          marginHorizontal="0.5em"
                          onClick={() => {
                            const payload = {
                              programEnrollmentMetadataId: _.get(
                                programMetadata,
                                'id',
                                null,
                              ),
                              program_file_key: _.get(programFileOption, 'key', null),
                              accountId: currentUser.account_id,
                            }
                            setLoading(true)
                            programService
                              .deleteProgramFileAPICall(payload)
                              .then((data) => {
                                setLoading(false)
                                setProgramMetadata(data.data.data)
                              })
                              .catch((err) => {
                                setLoading(false)
                              })
                            setProgramFileOption(null)
                          }}
                        />
                      ) : null}

                      <OutlinedButton
                        label="Download"
                        marginHorizontal="0.5em"
                        onClick={() => {
                          const payload = {
                            programEnrollmentMetadataId: _.get(
                              programMetadata,
                              'id',
                              null,
                            ),
                            program_file_key: _.get(programFileOption, 'key', null),
                            accountId: currentUser.account_id,
                          }
                          setLoading(true)
                          programService
                            .downloadProgramFileAPICall(payload)
                            .then((data) => {
                              setLoading(false)
                              setProgramFileDownloadLink(data.data.data)
                            })
                            .catch((err) => {
                              setLoading(false)
                            })
                        }}
                      />
                      {!props.isViewOnly && props.isAdmin ? (
                        <OutlinedButton
                          label="Upload Again"
                          marginHorizontal="0.5em"
                          onClick={() => {
                            setProgramFileKey(programFileOption.key)
                            hiddenFileInput.current.click()
                          }}
                        />
                      ) : null}
                    </Box>
                  </Box>
                ) : null}
              </Paper>
            }
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={openSnackBarFileSize}
              onClose={handleSnackBarFileSizeClose}
              key={'top' + 'center'}
            >
              <Alert onClose={handleSnackBarFileSizeClose} severity="warning">
                Only files of size less than 10 MB allowed
              </Alert>
            </Snackbar>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={openSnackBarFileType}
              onClose={handleSnackBarFileTypeClose}
              key={'top' + 'center'}
            >
              <Alert onClose={handleSnackBarFileTypeClose} severity="warning">
                Only valid PDFs allowed
              </Alert>
            </Snackbar>
          </Box>
          <Loader loading={loading} />
          <DisplayMessage
            open={showMessage}
            message={message}
            messageType={messageType}
            handleClose={() => setShowMessage(false)}
          />
        </>
      }
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getProgramById: (payload) => dispatch(getProgramById(payload)),
})

const mapStateToProps = ({ auth, programs }) => {
  const { currentUser, accountId, isAdmin, isSuperAdmin, isViewOnly } = auth
  const { programDetails, programId, notFound } = programs
  return { currentUser, programDetails, programId, accountId, isAdmin, isSuperAdmin, isViewOnly, notFound }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProgramDetails)
